import React, { useEffect, useMemo, useRef, useState } from 'react';

import Quill from 'quill';

import 'quill/dist/quill.snow.css';

export default function QuillEditor({ id, name, value, onChange, maxLength }) {
  const { quill, quillRef } = useQuill({
    theme: 'snow',

    modules: {
      toolbar: [
        [{ 'size': [] }],
        [ 'bold', 'italic', 'underline', 'strike' ],
        [{ 'script': 'super' }, { 'script': 'sub' }],
        [{ 'header': '1' }, { 'header': '2' }, 'blockquote' ],
        [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'align': [] }],
        [ 'formula' ],
        [ 'clean' ]
      ]
    }
  });

  const textarea = useRef();

  useEffect(() => {
    if (!quill) return;

    quill.on('text-change', () => {
      if (quill.getLength() > maxLength) {
        quill.deleteText(maxLength, quill.getLength());
      }
      const content = quill.root.innerHTML;

      textarea.current.value = content;
      onChange(content);
    });
  }, [quill, onChange]);

  return useMemo(() => (
    <>
      <div ref={quillRef} dangerouslySetInnerHTML={{ __html: value }} />
      <textarea ref={textarea} id={id} name={name} value={value} readOnly hidden />
    </>
  ), [id, name]);
};

function useQuill(options) {
  const quillRef = useRef();
  const [isLoaded, setIsLoaded] = useState(false);

  const [obj, setObj] = useState({
    quillRef,
    quill: undefined,
  });

  useEffect(() => {
    if (!obj.quill && quillRef.current && isLoaded) {
      const quill = new Quill(quillRef.current, options);

      setObj({ ...obj, quill });
    }

    setIsLoaded(true);
  }, [isLoaded, obj, options]);

  return obj;
}
